module.exports = __webpack_public_path__ + "static/media/corporateGroup.b03b53c4.svg";